import { Component, OnInit } from '@angular/core';
import { FieldConfig } from 'src/app/core/interfaces/field-config';
import { UntypedFormGroup } from '@angular/forms';
import { Option } from 'src/app/core/interfaces/options-dynamicform';
import { BroadcastService } from 'src/app/shared/services/broadcast.service';
import { DynamicFormServiceService} from 'src/app/shared/services/dynamic-form-service.service';

@Component({
    selector: 'app-radio-button-form',
    templateUrl: './radio-button-form.component.html',
    styleUrls: ['./radio-button-form.component.scss'],
    standalone: false
})
export class RadioButtonFormComponent implements OnInit {

  field: FieldConfig;
  group: UntypedFormGroup;
  isRequired: boolean;
  clearQuestions: string[] = [];
  sortedOptions: Option[];

  constructor(private broadCastService: BroadcastService, private dynamicService: DynamicFormServiceService) { }

  ngOnInit() {
    this.sortedOptions = this.sortedSequence();
    this.isRequired = this.dynamicService.checkHasRequired(this.field);
  }


  radioChange(option: Option) {
    this.clearQuestions = [];
    const labelCodeExist = this.dynamicService.revealChildLabelCodes(this.field.childAoeDtos, option, this.field.labelCode);
    const childAllLabelCodes = this.dynamicService.getAllChildAOEcodeFomParent(this.field);
    if (childAllLabelCodes.length > 0) { this.broadCastService.broadcast('CLEAR_OPTIONS', childAllLabelCodes); }
    if (labelCodeExist !== -1) {
      this.broadCastService.broadcast('SHOW_OPTIONS', labelCodeExist);
    }
  }

  private sortedSequence() {
    if (this.field && this.field.options) {
      return ((this.field.labelCode === 'SONOID' ||
        this.field.labelCode === 'SSUPER') ?
        this.field.options.sort((a, b) => {
          const left = a.value.toUpperCase();
          const right = b.value.toUpperCase();
          if (left < right) {
            return -1;
          }
          if (left > right) {
            return 1;
          }
          return 0;
        }) : this.field.options.sort((a, b) => a.sequence - b.sequence));
      }
  }

}
